module.exports = __webpack_public_path__ + "img/gu.52601970.svg";